import { useState, useEffect } from 'react'

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const testimonials = [
    {
      name: 'Priya Sharma',
      city: 'Mumbai',
      state: 'Maharashtra',
      content: 'Unitrade International has transformed our supply chain operations. Their expertise in customs clearance and freight forwarding has reduced our shipping costs by 25% while improving delivery times. Outstanding service!',
      image: '👩‍💼',
      rating: 5
    },
    {
      name: 'Rajesh Kumar',
      city: 'Jodhpur',
      state: 'Rajasthan',
      content: 'Working with Unitrade International for over 3 years has been exceptional. Their air freight services are reliable, and their customer support team is always available to handle urgent shipments. Highly recommended for international trade.',
      image: '👨‍💼',
      rating: 5
    },
    {
      name: 'Anjali Patel',
      city: 'Ahmedabad',
      state: 'Gujarat',
      content: 'The warehousing and distribution services provided by Unitrade International have streamlined our inventory management. Their technology platform gives us real-time visibility, and their team is incredibly professional.',
      image: '�',
      rating: 5
    }
  ]

  const partners = [
    { name: 'NYSE', logo: '📈' },
    { name: 'NASDAQ', logo: '💹' },
    { name: 'CME', logo: '📊' },
    { name: 'Binance', logo: '₿' },
    { name: 'Coinbase', logo: '🪙' },
    { name: 'Interactive Brokers', logo: '🏦' }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length)
    }, 5000)

    return () => clearInterval(interval)
  }, [testimonials.length])

  const handleDotClick = (index) => {
    setCurrentIndex(index)
  }

  return (
    <section id="testimonials" className="section-container bg-black">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          What Our Clients Say
        </h2>
        <p className="text-xl text-gray-400">
          Trusted worldwide for dependable logistics and supply chain efficiency.
        </p>
      </div>

      {/* Testimonial Carousel */}
      <div className="max-w-4xl mx-auto mb-16">
        <div className="card relative overflow-hidden">
          <div className="flex transition-transform duration-500 ease-in-out"
               style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {testimonials.map((testimonial, index) => (
              <div key={index} className="min-w-full px-8 py-6">
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-accent-orange" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
                <p className="text-lg text-gray-700 dark:text-gray-300 mb-6 italic">
                  "{testimonial.content}"
                </p>
                <div className="flex items-center">
                  <div className="text-4xl mr-4">{testimonial.image}</div>
                  <div>
                    <div className="font-bold text-secondary dark:text-white">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-600 dark:text-gray-400">
                      {testimonial.city}, {testimonial.state}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots Navigation */}
        <div className="flex justify-center mt-6 space-x-2">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => handleDotClick(index)}
              className={`w-3 h-3 rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-primary ${
                index === currentIndex
                  ? 'bg-primary w-8'
                  : 'bg-gray-300 dark:bg-gray-600 hover:bg-gray-400'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
              aria-current={index === currentIndex}
            />
          ))}
        </div>
      </div>

      {/* Partner Exchanges - Remove this section */}
    </section>
  )
}

export default Testimonials
